import template from "../html/dialog-config-ph.html";
import css from "../css/dialog-config-ph.css";
import Dialog from "dialog";
import sleep from "sleep";


class ConfigPHDialog extends Dialog {
	static get template() {
		return template;
	}
	static get css() {
		return css;
	}
	static constructor() {
		customElements.define("fulljs-dialog-config-ph", ConfigPHDialog);
	}
	constructor() {
		super();

		document.addEventListener("onupdatedevices", this.onupdatedevices_handler.bind(this));

		this.onupdatedevices_handler({detail: application.devices});

		this.show();
	}
	async buttonClearCalibration_click() {
      try {
        this.buttonClearCalibration.style.pointerEvents = "none";
        this.buttonClearCalibration.icon.iconname = "view-refresh";
        await server.rcall("RM_pHSensor_clearCalibration");
        this.buttonClearCalibration.icon.iconname = "dialog-ok-apply";
      } catch(e) {
        this.buttonClearCalibration.icon.iconname = "process-stop";
      } finally {
        await sleep(3000);
        this.buttonClearCalibration.icon.iconname = "dialog-ok";
        this.buttonClearCalibration.style.pointerEvents = "";
      }
	}
	async buttonCalibrateTo7_click() {
      try {
        this.buttonCalibrateTo7.style.pointerEvents = "none";
        this.buttonCalibrateTo7.icon.iconname = "view-refresh";
        await server.rcall("RM_pHSensor_calibrateTo7");
        this.buttonCalibrateTo7.icon.iconname = "dialog-ok-apply";
      } catch(e) {
        this.buttonCalibrateTo7.icon.iconname = "process-stop";
      } finally {
        await sleep(3000);
        this.buttonCalibrateTo7.icon.iconname = "dialog-ok";
        this.buttonCalibrateTo7.style.pointerEvents = "";
      }
	}
	async buttonCalibrateTo4_click() {
      try {
        this.buttonCalibrateTo4.style.pointerEvents = "none";
        this.buttonCalibrateTo4.icon.iconname = "view-refresh";
        await server.rcall("RM_pHSensor_calibrateTo4");
        this.buttonCalibrateTo4.icon.iconname = "dialog-ok-apply";
      } catch(e) {
        this.buttonCalibrateTo4.icon.iconname = "process-stop";
      } finally {
        await sleep(3000);
        this.buttonCalibrateTo4.icon.iconname = "dialog-ok";
        this.buttonCalibrateTo4.style.pointerEvents = "";
      }
	}
	async buttonCalibrateTo10_click() {
      try {
        this.buttonCalibrateTo10.style.pointerEvents = "none";
        this.buttonCalibrateTo10.icon.iconname = "view-refresh";
        await server.rcall("RM_pHSensor_calibrateTo10");
        this.buttonCalibrateTo10.icon.iconname = "dialog-ok-apply";
      } catch(e) {
        this.buttonCalibrateTo10.icon.iconname = "process-stop";
      } finally {
        await sleep(3000);
        this.buttonCalibrateTo10.icon.iconname = "dialog-ok";
        this.buttonCalibrateTo10.style.pointerEvents = "";
      }
	}  
	onupdatedevices_handler(event) {
		var devices = event.detail;

		this.textboxDeviceID.value = devices.pHSensor.id;
		this.textboxDeviceStatus.value = devices.pHSensor.status;
		this.textboxValue.value = devices.pHSensor.value;
		this.textboxCalibrationStatus.value = devices.pHSensor.calibrationStatus;
        this.textboxInternalTemperature.value = devices.pHSensor.internalTemperature;
        this.textboxSlope.value = devices.pHSensor.slope;
	}
	buttonClose_click(event) {
		this.close();
	}
	close() {
		super.close();
	}
}

ConfigPHDialog.constructor();

export default ConfigPHDialog;